<template>
  <div class="Userinfo">
    <el-popover
    placement="right"
    trigger="click"
    v-model="visible"
    >
    <div>
        <div class="row"><span>ID号:</span>{{uinfo.id}}</div>
        <div class="row"><span>名称:</span>{{uinfo.username}}<span class="fr" @click="goUserInfo"><i class="el-icon-edit"></i></span></div>
        <div class="row"><span>姓名:</span>{{uinfo.realname}}</div>
        <div class="row"><span>电话:</span>{{uinfo.mobile}}</div>
        <div class="row"><span>级别:</span>{{uinfo.levelname}}</div>
        <div class="row"><span>库存:</span>{{uinfo.stock}}</div>
        <div class="row"><span>上阶:</span>{{uinfo.parentname}}</div>
    </div>
    <span slot="reference" class="iconbtn" @click="getUserInfo"><i class="el-icon-user-solid" ></i></span>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'Userinfo',
  props: {
    userid:Number
  },
  data(){
    return{
       uinfo:{id:'',username:'',realname:'',mobile:'',levelname:'',stock:'',parentname:''},
       visible:false 
    }
  },
  methods: {
     getUserInfo(){
       this.$post("/user/getUserInfo",{userid:this.userid}).then((data)=>{
           if(data.result.success){
             this.uinfo=data.result.info
             this.visible=true
           }
       }) 
     },
     goUserInfo(){
        this.$go("/userinfo?userid="+this.userid)
     }
  },
}
</script>

<style scoped lang="scss">
.Userinfo{display: inline;}  
.iconbtn{border: 1px solid #f4f4f5;background-color: #f4f4f5;padding: 2px;}
.row{border-bottom: 1px dashed #ccc;font-size:14px;color:#333;padding: 0.15rem;}
.row span{text-align: right;}
.fr{float:right;}
</style>
